import React, { Fragment } from "react";
import { string, shape, func, bool } from "prop-types";
import classNames from "classnames";
import ThemeConsumer from "../ThemeConsumer";
import pixQrCode from "../../../assets/svg/iconPix.svg"


const ButtonPix = ({ theme, preset, onClick, disabled, className, id }) => {
  const classes = classNames(
    { [theme[preset]]: preset },
    { [theme.buttonImage]: !preset },
    className
  );

  return (
    <Fragment>
      <button
        id={id}
        type="button"
        className={disabled ? theme.buttonImageDisabled : classes}
        onClick={onClick}
      >
        <img src={pixQrCode} alt="" className={theme.qrCode} />
        PIX
      </button>
    </Fragment>
  );
};

ButtonPix.propTypes = {
  preset: string,
  onClick: func,
  theme: shape({
    button: string,
  }),
  disabled: bool,
  id: string,
};

ButtonPix.defaultProps = {
  theme: {},
  onClick: null,
  preset: "buttonPix",
  disabled: false,
};

export default ThemeConsumer("UIButtonPix")(ButtonPix);



// WEBPACK FOOTER //
// ./src/shared/components/Button/ButtonPix.js